import React from "react"
// import { css } from "@emotion/core"
import { graphql } from "gatsby"
// import { rhythm } from "../../utils/typography"
import Layout from "./layout"


import Collapse from '@material-ui/core/Collapse'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'



const IndexPage = ({ data }) => {

  const [week1, showSchedule1] = React.useState(true)
  const [week2, showSchedule2] = React.useState(true)
  const [week3, showSchedule3] = React.useState(true)
  const [week4, showSchedule4] = React.useState(true)
  const [week5, showSchedule5] = React.useState(true)
  const [week6, showSchedule6] = React.useState(true)
  const [week7, showSchedule7] = React.useState(true)
  const [week8, showSchedule8] = React.useState(true)
  const [week9, showSchedule9] = React.useState(true)
  const [week10, showSchedule10] = React.useState(true)
  const [week11, showSchedule11] = React.useState(true)
  const [week12, showSchedule12] = React.useState(true)
  const [week13, showSchedule13] = React.useState(true)
  const [week14, showSchedule14] = React.useState(true)





  function handleClick1(id) {
    switch (id) {
      case "week1":
        showSchedule1(!week1)
        break;
    }
  }
  function handleClick2(id) {
    switch (id) {
      case "week2":
        showSchedule2(!week2)
        break;
    }
  }

  function handleClick3(id) {
    switch (id) {
      case "week3":
        showSchedule3(!week3)
        break;
    }
  }

  function handleClick4(id) {
    switch (id) {
      case "week4":
        showSchedule4(!week4)
        break;
    }
  }

  function handleClick5(id) {
    switch (id) {
      case "week5":
        showSchedule5(!week5)
        break;
    }
  }
  function handleClick6(id) {
    switch (id) {
      case "week6":
        showSchedule6(!week6)
        break;
    }
  }
  function handleClick7(id) {
    switch (id) {
      case "week7":
        showSchedule7(!week7)
        break;
    }
  }
  function handleClick8(id) {
    switch (id) {
      case "week8":
        showSchedule8(!week8)
        break;
    }
  }

  function handleClick9(id) {
    switch (id) {
      case "week9":
        showSchedule9(!week9)
        break;
    }
  }

  function handleClick10(id) {
    switch (id) {
      case "week10":
        showSchedule10(!week10)
        break;
    }
  }

  function handleClick11(id) {
    switch (id) {
      case "week11":
        showSchedule11(!week11)
        break;
    }
  }

  function handleClick12(id) {
    switch (id) {
      case "week12":
        showSchedule12(!week12)
        break;
    }
  }
  function handleClick13(id) {
    switch (id) {
      case "week13":
        showSchedule13(!week13)
        break;
    }
  }
  function handleClick14(id) {
    switch (id) {
      case "week14":
        showSchedule14(!week14)
        break;
    }
  }


  return (

    <Layout>
      <h1>
        <p>Web as Medium 1</p>
        <p>
          GRAPH-3237-01 (29750), Fall 2024 <br />
          Tuesdays, 1:10 – 6:10pm, RISD <br />
          DC 404, 30 N Main St, Providence, RI 02903 <br />
          Instructor: Minkyoung Kim, mkim37@risd.edu <br />
          TA: Ash Ma, wma@risd.edu  <br />
          Office hours:  By <a href="https://mkim.netlify.app/officehours" target="_blank">appointment</a>
          <span class="indent">Wednesdays, 9:00 – 10:30am (in-person)</span><br /> <span class="indent">Fridays, 8:00 – 9:30am (remote)</span><br />
        </p>
      </h1>
      <div className="accordion-list">
        <ListItem id='week1' className="accordion" button onClick={() => handleClick1("week1")}>
          <ListItemText primary='Week 01: 09/10/24' className="accordion-heading  maxw-30" /> Hello World
        </ListItem>
        <Collapse in={!week1} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <div className="accordion-content">
              <ul>
                <li>Class introduction</li>
                <li>Student introduction</li>
                <li>Discuss presentation and class expectations</li>
                <li>Set-up accounts and software</li>
                <ul>
                  <li>Web browser: <a href="https://www.google.com/chrome/" target="_blank" rel="noopener noreferrer">Chrome</a>, <a href="https://www.mozilla.org/en-US/" target="_blank" rel="noopener noreferrer" rel="noopener noreferrer">Firefox</a>, or Safari</li>
                  <li>Text editor: <a href="https://www.sublimetext.com/" target="_blank" rel="noopener noreferrer">Sublime</a></li>
                  <li>Web prototype tool: <a href="http://figma.com" target="_blank" rel="noopener noreferrer">Figma</a> or Adobe XD</li>
                  <li>Hosting space: <a href="http://github.com" target="_blank" rel="noopener noreferrer" >Github</a> (<a href="https://docs.google.com/document/d/1vk6vJiTXhBOPzLV6Qt5Xkc3Q-IgyIl4uN5zsw0bEttY/edit?usp=sharing" target="_blank" rel="noopener noreferrer">Getting Started</a>)</li>
                  <li><a href="https://wam1f24.slack.com/" target="_blank" rel="noopener noreferrer">Slack</a></li>
                </ul>
                <li>Talk</li>
                <ul>
                  <li><a href="https://docs.google.com/presentation/d/1tmh-Ra_5Odm4QaymQ4UzrX9DZIRrBTwVaNqfxBThMT4/edit?usp=sharing" target="_blank" rel="noopener noreferrer">HTML Basics</a></li>
                  <li><a href="https://docs.google.com/presentation/d/1Ynk454_yPszFW88JtxxzCSdCNwi1YIk5-yuKmUEor10/edit?usp=sharing" target="_blank" rel="noopener noreferrer">How the Internet Works and How to Stay Organized</a></li>
                </ul>
                <li>Assignments due next week</li>
                <ul>
                  <li>Track A: finish Exercise 1 and 2 </li>
                  <li>Reading response</li>
                    <ul>
                      <li><a href="http://writing.upenn.edu/epc/authors/goldsmith/if_it_doesnt_exist.html" target="_blank" rel="noopener noreferrer">If it Doesn’t Exist on the Internet, It Doesn’t Exist</a></li>
                      <li><a href="https://theoutline.com/post/4560/asian-american-writers-wikipedia-edit-a-thon-kundiman-aaww?zd=2&zi=ardr4wjs" target="_blank" rel="noopener noreferrer">If an Asian American Author Doesn’t Have a Wikipedia Page, Do They Exist?</a></li>
                      <li><a href="https://restofworld.org/2024/singapore-writers-reject-ai-training/" target="_blank">Writers and Publishers in Singapore Reject a Government Plan to Train AI on Their Work</a></li>
                    </ul>
                  
                </ul>
              </ul>
            </div>
          </List>
        </Collapse>
        <ListItem id='week2' className="accordion" button onClick={() => handleClick2("week2")}>
          <ListItemText primary='Week 02: 09/17/24' className="accordion-heading  maxw-30" /> The Internets
        </ListItem>
        <Collapse in={!week2} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <div className="accordion-content">
              <ul>
                <li>Reading discussion</li> 
                <ul>
                    <li><a href="http://writing.upenn.edu/epc/authors/goldsmith/if_it_doesnt_exist.html" target="_blank" rel="noopener noreferrer">If it Doesn’t Exist on the Internet, It Doesn’t Exist</a></li>
                    <li><a href="https://theoutline.com/post/4560/asian-american-writers-wikipedia-edit-a-thon-kundiman-aaww?zd=2&zi=ardr4wjs" target="_blank" rel="noopener noreferrer">If an Asian American Author Doesn’t Have a Wikipedia Page, Do They Exist?</a></li>
                    <li><a href="https://restofworld.org/2024/singapore-writers-reject-ai-training/" target="_blank">Writers and Publishers in Singapore Reject a Government Plan to Train AI on Their Work</a></li>
                </ul>
                <li>Student presentation: Li June</li>
                <li>Lectures</li>
                <ul>
                  <li><a href="https://docs.google.com/presentation/d/1883O4vLytZ-EYaIAywko991n_6b9aNIP1DgSiEjns3E/edit?usp=sharing" target="_blank" rel="noopener noreferrer">CSS form and content</a></li>
                  <li><a href="https://docs.google.com/presentation/d/1lK0gxY9rQ1YiWGYLFniFbaEfrVLSoMU3KdUKOLvpMQo/edit?usp=sharing" target="_blank" rel="noopener noreferrer">CSS layout</a></li>
                </ul>
                <li>Exercise 2: group review</li>
                <li>Introduction of Exercise 3</li>
                <li>Assignments due next week</li>
                <ul>
                  <li>Finish Exercise 3 </li>
                  <li>Suggested Codeacademy tracks</li>
                  <ul>
                    <li>CSS: Selectors and visual rules</li>
                    <li>CSS: The box model</li>
                    <li>CSS: Display and positioning</li>
                  </ul>
                  <li>Recommended reading: <a href="http://www.coldbacon.com/writing/borges-garden.html#_jmp0_" target="_blank" rel="noopener noreferrer">The Garden of Forking Paths</a>, <a href="https://content.sakai.rutgers.edu/access/content/user/jpsmall/JPSmall-Offprints/JPSmall-Is%20Linear%20Perspective%20Necessary.pdf" target="_blank" rel="noopener noreferrer">Is Linear Perspective Necessary?</a></li>
                </ul>
              </ul>
            </div>
          </List>
        </Collapse>
        <ListItem id='week3' className="accordion" button  onClick={() => handleClick3("week3")}>
          <ListItemText primary='Week 03: 09/24/24' className="accordion-heading  maxw-30" /> Hyperlinks
        </ListItem>
        <Collapse in={!week3} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <div className="accordion-content">
              <ul>
                <li>Student presentation: Radhika</li>
                <li>Lecture/demo: <a href="https://docs.google.com/presentation/d/1q9IiIeKugwqfIu1Pvind2HTaXqnl2j6QNqHaDSV6BSM/edit?usp=sharing" target="_blank" rel="noopener noreferrer">CSS transforms</a></li>
                <li>Introduction of Exercise 4: CSS Letterforms (1)</li>
                <li>Exercise 3: small group review</li>

                <li>Assignments due next week</li>
                <ul>
                  <li>Finish Exercise 4</li>
                  <li>Suggested Codeacademy tracks</li>
                  <ul>
                    <li>CSS: Colors</li>
                    <li>CSS: Typography</li>
                    <li>CSS: Grid</li>
                  </ul>
                  <li>Suggested reading: <a href="https://unbag.net/end/black-gooey-universe" target="_blank" rel="noopener noreferrer">Black Gooey Universe</a> and <a href="http://contemporary-home-computing.org/vernacular-web-2/" target="_blank" rel="noopener noreferrer">Vernacular Web 2</a></li>

                </ul>
              </ul>
            </div>
          </List>
        </Collapse>
        <ListItem id='week4' className="accordion" button onClick={() => handleClick4("week4")}>
          <ListItemText primary='Week 04: 10/01/24' className="accordion-heading  maxw-30" /> Interface Aesthetics
        </ListItem>
        <Collapse in={!week4} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <div className="accordion-content">
              <ul>
                <li>Student presentation: Sophie</li>
                <li>Lecture: <a href="https://docs.google.com/presentation/d/1FfDV8auUwKh8GbIPtjRiaTgoF-y3Secy0eS7ZR8Pvpc/edit?usp=sharing" target="_blank" rel="noopener noreferrer">CSS motion</a></li>
                <li>Exercise 4: group review</li>
                <li>Introduction of Exercise 5: CSS Letterforms (2)</li>
                <li>Introduction of Projecg 1: Hyperlinked Set</li>
                <li>Assignments due next week</li>
                <ul>
                  <li>Finish Exercise 5</li>
                  <li>Project 1: planning/sketch</li>
                  <li>Suggested Codeacademy tracks: catch up on any incomplete ones</li>
                  <li>Recommended reading: <a href="https://openresearch.lsbu.ac.uk/download/2057497e2257aae4a78f52a88d791aa11bc5a0f35fd2fb1f8225ebdc143767fc/87600/lostandliving_binnen_sluis.pdf" target="_blank" rel="noopener noreferrer">Accumulate · Aggregate · Destroy: Database Fever and the Archival Web</a></li>
                </ul>
              </ul>
            </div>
          </List>
        </Collapse>
        <ListItem id='week5' className="accordion" button  onClick={() => handleClick5("week5")}>
          <ListItemText primary='Week 05: 10/08/24' className="accordion-heading  maxw-30" />  Collection
        </ListItem>
        <Collapse in={!week5} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <div className="accordion-content">
              <ul>
                <li>Student presentation: Claire</li>
                {/* <li>Reading discussion:  <a href="https://www.dropbox.com/scl/fi/wx7c9odlxgeopttk666zj/david_reinfurt_infinite_versioning.pdf?rlkey=eb18wp6paadcxknoy125qkji5&dl=0" target="_blank" rel="noopener noreferrer">Infinite Versioning</a></li> */}
                <li>Lecture: <a href="https://docs.google.com/presentation/d/1xCqxZ_ehd-W5N0SjQv3qcJ9XZViUGDfIxRPWYqLBaEY/edit?usp=sharing" target="_blank" rel="noopener noreferrer">JavaScript basics</a></li>
                <li>Project 2 & Exercise 5: small group review</li>
                <li>Exercise 6: Dark Mode </li>
                <li>Assignments due next week</li>
                <ul>
                  <li>Project 2: design</li>
                  <li>Suggested Codeacademy tracks: <a href="https://www.codecademy.com/learn/introduction-to-javascript" target="_blank" rel="noopener noreferrer">Introduction of JavaScript</a></li>
                  <ul>
                    <li>Introduction</li>
                    <li>Conditionals</li>
                  </ul>
                  {/* <li>Reading response: <a href="https://www.dropbox.com/scl/fi/wx7c9odlxgeopttk666zj/david_reinfurt_infinite_versioning.pdf?rlkey=eb18wp6paadcxknoy125qkji5&dl=0" target="_blank" rel="noopener noreferrer">Infinite Versioning</a></li> */}

                  <li>Suggested reading: <a href="https://www.e-flux.com/journal/10/61362/in-defense-of-the-poor-image/" target="_blank" rel="noopener noreferrer">In Defense of the Poor Image</a></li>
                </ul>
              </ul>
            </div>
          </List>
        </Collapse>
        <ListItem id='week6' className="accordion" button onClick={() => handleClick6("week6")}>
          <ListItemText primary='Week 06: 10/15/24' className="accordion-heading  maxw-30" /> Repoduction
        </ListItem>
        <Collapse in={!week6} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <div className="accordion-content">
              <ul>
                <li>Student presentation: Lea, Janice, and Brianna</li>
                <li>Project 1: group review</li>

                {/* <li>Lecture/demo: <a href="https://github.com/RISD-Code-Lab/spring2021/tree/main/session-02" target="_blank" rel="noopener noreferrer">Using Randomness</a></li> */}
                <li>Assignments due next week</li>
                <ul>
                  <li>Project 1: prototype</li>
                  <li>Suggested reading/watching:  <a href="https://www.dropbox.com/s/p5nf2esihc6r6ca/ghost_in_the_machine.pdf?dl=0" target="_blank" rel="noopener noreferrer">Challenging the Algorithms of Oppression</a>, and <a href="https://www.newyorker.com/tech/annals-of-technology/chatgpt-is-a-blurry-jpeg-of-the-web" target="_blank" rel="noopener noreferrer">ChatGPT is a Blurry JPEG of the Web</a></li>
                  <li>Suggested Codeacademy tracks: <a href="https://www.codecademy.com/learn/introduction-to-javascript" target="_blank" rel="noopener noreferrer">Introduction of JavaScript</a></li>
                  <ul>
                    <li>Functions</li>
                    <li>Scope</li>
                    <li>Arrays</li>
                  </ul>
                </ul>
              </ul>
            </div>
          </List>
        </Collapse>
        <ListItem id='week7' className="accordion" button  onClick={() => handleClick7("week7")}>
          <ListItemText primary='Week 07: 10/22/24' className="accordion-heading  maxw-30" /> Working wiht Data
        </ListItem>
        <Collapse in={!week7} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <div className="accordion-content">
              <ul>
                <li>Student presentation: Hyunmin</li>
                <li>Lecture: <a href="https://docs.google.com/presentation/d/11zOVELKfuG9mP2ZgPkbA0wZE-yDjE9NSBW9WXGlkgq4/edit?usp=drive_link" target="_blank" rel="noopener noreferrer">Responsive Web</a></li>
                <li>Project 2: 1:1 review</li>
                <li>Exercise 7: Media Query Relay (1/4)</li>
                <li>Assignments due next week</li>
                <ul>
                  <li>Finish Project 2</li>
                  <li>Suggested Codeacademy tracks: <a href="https://www.codecademy.com/learn/introduction-to-javascript" target="_blank" rel="noopener noreferrer">Introduction of JavaScript</a></li>
                  <ul>
                    <li>Loop</li>
                    <li>Iterators</li>
                    <li>Objects</li>
                  </ul>

                </ul>
              </ul>
            </div>
          </List>
        </Collapse>
        <ListItem id='week8' className="accordion" button  onClick={() => handleClick8("week8")}> 
          <ListItemText primary='Week 08: 10/29/24' className="accordion-heading  maxw-30" /> Change over Time
        </ListItem>
        <Collapse in={!week8} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <div className="accordion-content">
              <ul>
                <li>Student presentation: Jolin</li>
                <li>Project 1: Big group review</li>
                <li>Introduction of Project 2</li>
                <li>Assignments due next week</li>
                <ul>
                  <li>Project 2: planning/sketch</li>
                  <li>Suggested reading: <a href="https://www.dropbox.com/scl/fi/wx7c9odlxgeopttk666zj/david_reinfurt_infinite_versioning.pdf?rlkey=eb18wp6paadcxknoy125qkji5&dl=0" target="_blank">Infinite Versioning</a></li>

                  {/* <li>Suggested reading: <a href="http://adht.parsons.edu/designstudies/plot/designing-in-liquid-times-generative-graphic-design-in-an-age-of-uncertainty/" target="_blank" rel="noopener noreferrer">Generative Graphic Design in an Age of Uncertainty</a></li> */}
                  <li>Suggested Codeacademy tracks: catch up on any incomplete ones </li>
                </ul>
              </ul>
            </div>
          </List>
        </Collapse>
        <ListItem id='week9' className="accordion" button  onClick={() => handleClick9("week9")}>
          <ListItemText primary='Week 09: 11/05/24' className="accordion-heading  maxw-30" /> Generative Design
        </ListItem>
        <Collapse in={!week9} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <div className="accordion-content">
              <ul>
                <li>Student presentation: Sejal and Cindy</li>
                <li>Project 2: small group review</li>
                <li>Exercise 7: Media Query Relay (2/4)</li>
                <li>Assignments due next week</li>
                <ul>
                  <li>Project 2: design</li>
                  <li>Suggested Codeacademy tracks: catch up on any incomplete ones </li>
                </ul>
              </ul>
            </div>
          </List>
        </Collapse>
        <ListItem id='week10' className="accordion" button  onClick={() => handleClick10("week10")}> 
          <ListItemText primary='Week 10: 11/12/24' className="accordion-heading  maxw-30" /> Users
        </ListItem>
        <Collapse in={!week10} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <div className="accordion-content">
              <ul>

                <li>Student presentation: Narin</li>
                <li>Project 2: small group review</li>
                <li>Exercise 7: Media Query Relay (3/4)</li>
                <li>Assignments due next week</li>
                <ul>
                  <li>Project 2: continue production</li>
                  <li>Suggested reading: <a href="https://ourdataourselves.tacticaltech.org/posts/30-on-weaponised-design/" target="_blank" rel="noopener noreferrer">On Weaponised Design</a> and  <a href="http://contentsmagazine.com/articles/made-to-measure/" target="_blank" rel="noopener noreferrer">Made to Measure</a></li>
                  <li>Suggested Codeacademy tracks: catch up on any incomplete ones </li>
                </ul>
              </ul>
            </div>
          </List>
        </Collapse>
        <ListItem id='week11' className="accordion" button  onClick={() => handleClick11("week11")}> 
          <ListItemText primary='Week 11: 11/19/24' className="accordion-heading  maxw-30" /> Platform
        </ListItem>
        <Collapse in={!week11} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <div className="accordion-content">
              <ul>
                <li>Student presentation: Michael and Cynthia</li>
                <li>Project 2: small group review</li>
                <li>Exercise 7: Media Query Relay (4/4)</li>
                <li>Assignments due next class</li>
                <ul>
                  <li>Project 2: test and launch your project on your Github repository.</li>
                  <li>Suggested Reading: <a href="http://linkedbyair.net/balkin.pdf" target="_blank" rel="noopener noreferrer">Sometimes it Looks like a Duck, Sometimes it Looks like a Rabbit</a></li>
                </ul>
              </ul>
            </div>
          </List>
        </Collapse>
        <ListItem id='week12' className="accordion" button disabled>
          {/* onClick={() => handleClick12("week12")}> */}
          <ListItemText primary='Week 12: 11/26/24' className="accordion-heading  maxw-30" /> Final
        </ListItem>
        <Collapse in={!week12} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <div className="accordion-content">
              <ul>
                <li>Project 3: Last group review</li>
                <li>Orientation for the final documentation: Upload final documentation package on <a href="https://www.dropbox.com/request/MJAdxcyP1py1VG50J9zK" target="_blank" rel="noopener noreferrer">Dropbox folder</a> and your Github repository. More details on <i><a href="https://docs.google.com/document/d/1ibamY_cnw9qqw1uvTyJG9J9KB0WJc9no1QMN3Cz_YR4/edit?usp=sharing" target="_blank" rel="noopener noreferrer">Final checklist</a></i>.
                  (Due 12/08/23)</li>
                <li>After class</li>
                <ul>
                  <li>Due 12/08/23: Upload final documentation package on <a href="https://www.dropbox.com/request/MJAdxcyP1py1VG50J9zK" target="_blank" rel="noopener noreferrer">Dropbox folder</a> and your Github repository. More details on <i><a href="https://docs.google.com/document/d/1ibamY_cnw9qqw1uvTyJG9J9KB0WJc9no1QMN3Cz_YR4/edit?usp=sharing" target="_blank" rel="noopener noreferrer">Final checklist</a></i>.</li>
                  <li>Recommended: Watch <a href="https://github.com/RISD-Code-Lab/spring2021/tree/main/session-05" target="_blank">Code Lab Session 5: Launch Website</a></li>
                </ul>
              </ul>
            </div>
          </List>
        </Collapse>
        <ListItem id='week13' className="accordion" button disabled>
          {/* onClick={() => handleClick13("week13")}> */}
          <ListItemText primary='Week 13: 12/08/24' className="accordion-heading  maxw-30" /> Class Documentation Due
        </ListItem>
        <Collapse in={!week13} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <div className="accordion-content">
              <ul>
                <li>Optional individual meetings</li>
                <li>After class</li>
                <ul>
                  <li>Due 12/08/23: Upload final documentation package on <a href="https://www.dropbox.com/request/MJAdxcyP1py1VG50J9zK" target="_blank" rel="noopener noreferrer">Dropbox folder</a> and your Github repository. More details on <i><a href="https://docs.google.com/document/d/1ibamY_cnw9qqw1uvTyJG9J9KB0WJc9no1QMN3Cz_YR4/edit?usp=sharing" target="_blank" rel="noopener noreferrer">Final checklist</a></i>.</li>
                </ul>
              </ul>
            </div>
          </List>
        </Collapse>
        
       
      </div>
      <h4></h4>
    </Layout>
  )
}

export default IndexPage




// export const query = graphql`
//   query {
//     allMarkdownRemark(
//         sort: { fields: [frontmatter___date], order: ASC } 
//         filter: {fileAbsolutePath: {regex: "/t3f19/_project/.*.md$/"}}
//         ) {
//       totalCount
//       edges {
//         node {
//           html
//           id
//           frontmatter {
//             title
//             date
//           }
//           fields {
//             slug
//           }
//         }
//       }
//     }
//   }
// `